import { api, unwrap } from './client';

export async function getReport(reportId, { period = 'all' } = {}) {
  return unwrap(api.get(`/api/reports/${reportId}`, { params: { period } }));
}
